<div *ngIf="!inventories?.length; else table">
    {{noDataMessage}}
</div>

<ng-template #table>
    <!-- <mat-slide-toggle color="primary" class="slide-button" [checked]="displayUnprovisionnedInventories" (change)="onToggleChange($event.checked)">
        Afficher les inventaires en statut UNPROVISIONED
    </mat-slide-toggle> -->

    <!-- <h3>{{ message }}</h3> -->

    <mat-card appearance="outlined" class="card-data-table">
        <syn-filter-bar
            searchPlaceholder="Rechercher un inventaire"
            [showToggle]="true"
            toggleLabel="Afficher les inventaires en statut UNPROVISIONED"
            (filterChange)="applyFilter($event.searchFilter, $event.input)"
            (toggleChange)="onToggleChange($event)">
        </syn-filter-bar>

        <mat-progress-bar
            *ngIf="loading"
            mode="indeterminate"
            class="table-loading-bar">
        </mat-progress-bar>

        <mat-table [dataSource]="dataSource" matSort>

            <!-- Name -->
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-column">Nom</mat-header-cell>
                <mat-cell *matCellDef="let row" class="name-column">
                    <syn-inventory-avatar
                        [inventory]="row"
                        [maxWidth]="'600px'"
                        [wrap]="true"
                        [showLegend]="true">
                    </syn-inventory-avatar>
                </mat-cell>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Statut</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.status}}</mat-cell>
            </ng-container>

            <!-- Environment -->
            <ng-container matColumnDef="environment">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Environnement</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.environment}}</mat-cell>
            </ng-container>

            <!-- Type/subtype -->
            <ng-container matColumnDef="type/subtype">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Type/Subtype</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.type}} / {{ row.subtype }}</mat-cell>
            </ng-container>

            <!-- Tags -->
            <ng-container matColumnDef="tags">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Tags</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-chip-listbox *ngIf="row.tags.length; else noTags">
                        <mat-chip disableRipple *ngFor="let tag of row.tags">{{tag}}</mat-chip>
                    </mat-chip-listbox>
                    <ng-template #noTags>
                        <small>Pas de tag.</small>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <mat-paginator
            *ngIf="showPaginator"
            #paginator
            [length]="totalSize ?? inventories?.length"
            [pageSizeOptions]="pageSizeOptions"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
        ></mat-paginator>
    </mat-card>
</ng-template>
